"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/order/v1/portal_service.proto (package spwn.order.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalOrderService = void 0;
const portal_service_pb_1 = require("./portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.order.v1.PortalOrderService
 */
exports.PortalOrderService = {
    typeName: "spwn.order.v1.PortalOrderService",
    methods: {
        /**
         * 注文の単体取得
         *
         * @generated from rpc spwn.order.v1.PortalOrderService.GetOrder
         */
        getOrder: {
            name: "GetOrder",
            I: portal_service_pb_1.PortalOrderServiceGetOrderRequest,
            O: portal_service_pb_1.PortalOrderServiceGetOrderResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 注文の一覧取得
         *
         * @generated from rpc spwn.order.v1.PortalOrderService.GetOrdersByBrandFirestoreId
         */
        getOrdersByBrandFirestoreId: {
            name: "GetOrdersByBrandFirestoreId",
            I: portal_service_pb_1.PortalOrderServiceGetOrdersByBrandFirestoreIdRequest,
            O: portal_service_pb_1.PortalOrderServiceGetOrdersByBrandFirestoreIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * カートの一覧取得
         *
         * @generated from rpc spwn.order.v1.PortalOrderService.GetCarts
         */
        getCarts: {
            name: "GetCarts",
            I: portal_service_pb_1.PortalOrderServiceGetCartsRequest,
            O: portal_service_pb_1.PortalOrderServiceGetCartsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * カートの単体取得
         *
         * @generated from rpc spwn.order.v1.PortalOrderService.GetCart
         */
        getCart: {
            name: "GetCart",
            I: portal_service_pb_1.PortalOrderServiceGetCartRequest,
            O: portal_service_pb_1.PortalOrderServiceGetCartResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * カートの追加
         *
         * @generated from rpc spwn.order.v1.PortalOrderService.UpdateCartItem
         */
        updateCartItem: {
            name: "UpdateCartItem",
            I: portal_service_pb_1.PortalOrderServiceUpdateCartItemRequest,
            O: portal_service_pb_1.PortalOrderServiceUpdateCartItemResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * カートの商品の購入を開始する
         *
         * @generated from rpc spwn.order.v1.PortalOrderService.StartCheckoutSessionFromCart
         */
        startCheckoutSessionFromCart: {
            name: "StartCheckoutSessionFromCart",
            I: portal_service_pb_1.PortalOrderServiceStartCheckoutSessionFromCartRequest,
            O: portal_service_pb_1.PortalOrderServiceStartCheckoutSessionFromCartResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * グッズIDから注文の一覧取得
         *
         * @generated from rpc spwn.order.v1.PortalOrderService.GetOrdersByGoodsId
         */
        getOrdersByGoodsId: {
            name: "GetOrdersByGoodsId",
            I: portal_service_pb_1.PortalOrderServiceGetOrdersByGoodsIdRequest,
            O: portal_service_pb_1.PortalOrderServiceGetOrdersByGoodsIdResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 購入前キャンセル
         *
         * @generated from rpc spwn.order.v1.PortalOrderService.CancelOrder
         */
        cancelOrder: {
            name: "CancelOrder",
            I: portal_service_pb_1.PortalOrderServiceCancelOrderRequest,
            O: portal_service_pb_1.PortalOrderServiceCancelOrderResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * カートの通知の取得
         *
         * @generated from rpc spwn.order.v1.PortalOrderService.GetCartsNotifications
         */
        getCartsNotifications: {
            name: "GetCartsNotifications",
            I: portal_service_pb_1.PortalOrderServiceGetCartsNotificationsRequest,
            O: portal_service_pb_1.PortalOrderServiceGetCartsNotificationsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * カートの内容を最新に更新する
         *
         * @generated from rpc spwn.order.v1.PortalOrderService.MarkCartNotificationsAsRead
         */
        markCartNotificationsAsRead: {
            name: "MarkCartNotificationsAsRead",
            I: portal_service_pb_1.PortalOrderServiceMarkCartNotificationsAsReadRequest,
            O: portal_service_pb_1.PortalOrderServiceMarkCartNotificationsAsReadResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=portal_service_connect.js.map